<div dropdown container="body" class="dropdown h-100" aria-haspopup="true" [dropup]="isDropup" placement="bottom right">
    <div dropdownToggle class="topbar-item" [ngClass]="{'pointer-events-none': !isLoginForFirstTime}" aria-expanded="false">
        <div [class]="customStyle" pTooltip="{{'Administration' | localize}}" tooltipPosition="bottom">
            <i class="menu-link-icon icon-superadmin d-inline-block"></i>
        </div>
    </div>
    <div *dropdownMenu class="dropdown-menu settings-topbar-menu super-admin-topbar-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-md dropdown-menu-right w-md-300px">
        <perfect-scrollbar>
            <div class="d-flex flex-column pl-2 pl-md-9 pt-2 pt-md-7 pb-2 pb-md-7 bgi-size-cover bgi-no-repeat rounded-top"
                 [ngStyle]="{ 'background': 'url(' + 'assets/common/images/header/settings_bg1.svg)', 'background-size': 'cover'}">
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-50 mr-2 mr-md-3">
                        <div class="symbol-label">
                            <img src="assets/common/images/sidebarmenuicon/Super_Admin_Side_Panel.svg" class="symbol-label" alt="" />
                        </div>
                    </div>
                    <div class="d-flex flex-column">
                        <span class="font-weight-bold font-size-h5 text-white topbar-username">
                            {{ isHostSuperAdmin ? ('Dashboard' | localize) : ('Super Admin' | localize) }}
                        </span>
                        <div class="navi mt-2">
                            <span class="text-white font-size-h6-sm">
                                {{'Administration' | localize}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navi navi-hover my-1 mx-2 ps" *ngIf="isHostSuperAdmin">
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Tenants')">
                    <div class="navi-link" (click)="getTenants()">
                        <div class="navi-icon mr-2">
                            <span class="menu-link-icon icon-tenant"></span>
                        </div>
                        <div class="navi-text">
                            <div>{{"Tenants" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Editions')">
                    <div class="navi-link" (click)="getEditions()">
                        <div class="navi-icon mr-2">
                            <span class="menu-link-icon icon-editions"></span>
                        </div>
                        <div class="navi-text">
                            <div>{{"Editions" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Tenants')">
                    <div class="navi-link" (click)="getTrialRequests()">
                        <div class="navi-icon mr-2">
                            <span class="menu-link-icon icon-trial-request"></span>
                        </div>
                        <div class="navi-text">
                            <div>{{"Trial Request" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Administration.Host.Settings')">
                    <div class="navi-link" (click)="getHostSettings()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Company-Profile.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"HostSettings" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Administration.Languages')">
                    <div class="navi-link" (click)="getLanguages()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/My-Profile.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"Languages" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Administration.AuditLogs')">
                    <div class="navi-link" (click)="getAuditLogs()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/LookupMetadata.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"AuditLogs" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Administration.Host.Maintenance')">
                    <div class="navi-link" (click)="getMaintenance()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Productivity.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"Maintenance" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Administration.UiCustomization')">
                    <div class="navi-link" (click)="getVisualSettings()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Workflows.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"VisualSettings" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="canViewKeka">
                    <div class="navi-link" (click)="getKeka()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Apps-Integations.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>Keka</div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="navi navi-hover my-1 mx-2 ps" *ngIf="!isHostSuperAdmin">
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages_SuperAdmin.Impersonate.user')">
                    <div class="navi-link" (click)="getProxyLogin()">
                        <div class="navi-icon mr-2">
                            <span class="menu-link-icon icon-superadmin"></span>
                        </div>
                        <div class="navi-text">
                            <div>{{"ProxyLogin" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.CompanyProfile')">
                    <div class="navi-link" (click)="getCompanyProfile()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Company-Profile.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"CompanyProfile" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.Administration.OrganizationUnits')">
                    <div class="navi-link" (click)="getOrganizationUnit()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/My-Profile.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"OrganizationUnit" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.ProductService')">
                    <div class="navi-link" (click)="getProductAndServiceNew()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Products-Services1.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"ProductServices" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.User.ViewUsers')">
                    <div class="navi-link" (click)="getManageUsers()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/manage-user.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"ManageUsers" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="canViewKeka">
                    <div class="navi-link" (click)="getKeka()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Apps-Integations.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>Keka</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.AppProductivity')">
                    <div class="navi-link" (click)="getAppCategory()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/Productivity.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"AppProductivity" | localize}}</div>
                        </div>
                    </div>
                </a>
                <a class="navi-item cursor-pointer" *ngIf="isGranted('Pages.AppProductivity')">
                    <div class="navi-link" (click)="getMasters()">
                        <div class="navi-icon mr-2">
                            <img src="assets/common/images/header/LookupMetadata.svg" height="38" alt="" />
                        </div>
                        <div class="navi-text">
                            <div>{{"LookupMetadata" | localize}}</div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="navi-text mx-2">
                <div class="pl-7 pb-5 pt-1" style="color: gray;">{{appSession.webAppVersion}}</div>
            </div>
        </perfect-scrollbar>
    </div>
</div>
